// ============================================================
// ANSICHTSSACHE-AGENT – „Mit Passkey anmelden"
// ============================================================
// Steht UNTER dem Kennwortformular und nicht darueber: der
// Passkey ist der bessere Weg, aber nicht der bekannte. Wer ihn
// hat, findet ihn auch unten; wer ihn nicht hat, soll nicht an
// einem Knopf vorbeisuchen muessen, der ihm nichts nuetzt.
//
// Ohne E-Mail-Feld — das ist der Sinn der Sache: der Browser
// fragt das Geraet, welche Schluessel es fuer diese Adresse hat,
// und zeigt sie zur Auswahl. Wer die Anwendung auf dem eigenen
// Rechner oeffnet, ist mit einem Fingerabdruck drin.
// ============================================================

"use client";

import { useState, useTransition } from "react";
import { startAuthentication } from "@simplewebauthn/browser";
import { AlertCircle, Fingerprint, Loader2 } from "lucide-react";
import { passkeyAnmelden, passkeyAufgabe } from "./passkey-actions";

export function PasskeyKnopf() {
  const [fehler, setFehler] = useState<string | null>(null);
  const [pending, startTransition] = useTransition();

  function anmelden() {
    setFehler(null);
    startTransition(async () => {
      try {
        const aufgabe = await passkeyAufgabe();
        const antwort = await startAuthentication({ optionsJSON: aufgabe });
        const ergebnis = await passkeyAnmelden(JSON.stringify(antwort));
        if (ergebnis?.error) setFehler(ergebnis.error);
      } catch (error) {
        // Der Abbruch ist der haeufigste Fall: Fenster weggeklickt,
        // Finger nicht erkannt, kein Passkey auf dem Geraet. Das
        // ist kein Fehler, den man rot anschreit.
        const name = (error as { name?: string })?.name;
        if (name === "NotAllowedError" || name === "AbortError") return;
        setFehler("Mit Passkey hat es nicht geklappt. Nimm dein Kennwort.");
      }
    });
  }

  return (
    <div className="mt-6">
      {/* Ein Strich mit Wort darin statt einer nackten Linie: er
          sagt „oder", nicht „hier endet etwas". */}
      <div className="flex items-center gap-3">
        <span className="border-border h-px flex-1 border-t dark:border-white/10" aria-hidden />
        <span className="text-caption text-text-tertiary">oder</span>
        <span className="border-border h-px flex-1 border-t dark:border-white/10" aria-hidden />
      </div>

      <button
        type="button"
        onClick={anmelden}
        disabled={pending}
        className="border-border-control text-body-md text-text-primary duration-fast ease-standard hover:bg-bg-tertiary mt-4 flex h-11 w-full items-center justify-center gap-2 rounded-lg border font-medium transition-all active:scale-[0.985] disabled:cursor-not-allowed disabled:opacity-60"
      >
        {pending ? (
          <>
            <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
            Warte auf dein Gerät…
          </>
        ) : (
          <>
            <Fingerprint className="h-4 w-4" aria-hidden />
            Mit Passkey anmelden
          </>
        )}
      </button>

      {fehler && (
        <div
          role="alert"
          className="border-danger/25 bg-danger/10 text-body-sm text-danger mt-3 flex items-start gap-2.5 rounded-lg border px-3.5 py-3"
        >
          <AlertCircle className="mt-px h-4 w-4 shrink-0" aria-hidden />
          <span>{fehler}</span>
        </div>
      )}
    </div>
  );
}
